<template>
  <div>
    <agile-table
      :data="users"
      :data-type="'users'"
      :table-meta="tableMeta"
      :filter-meta="filterMeta"
      :action-meta="actionMeta"
      :column-meta="columnMeta"
      @rowAction="rowAction"
      @fieldAction="fieldAction" />
    <new-button @clicked="openUserModal" />
    <slideout-panel />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import UserModal from '@/components/modals/UserModal'
import UserPinModal from '@/components/modals/UserPinModal'
import AgileTable from '@/components/table/AgileTable'

export default {
  components: {
    NewButton,
    UserModal,
    AgileTable
  },
  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      tableMeta: {
        headingIcon: 'fa-users-cog'
      },

      filterMeta: [{
        fieldId: 'initials',
        type: 'string',
        label: 'Initialer'
      },
      {
        fieldId: 'role',
        type: 'select',
        label: 'Roll',
        options: [{
          key: 'Staff',
          value: 'Konsult'
        }, {
          key: 'SuperAdmin',
          value: 'Superadmin'
        }, {
          key: 'Developer',
          value: 'Utvecklare'
        }]
      }],

      columnMeta: {
        hasActions: true,
        items: [{
          fieldId: 'initials',
          label: 'Initialer'
        },
        {
          fieldId: 'firstName',
          label: 'Förnamn'
        },
        {
          fieldId: 'lastName',
          label: 'Efternamn'
        },
        {
          fieldId: 'email',
          label: 'E-post',
          actionType: 'mailto'
        },
        {
          fieldId: 'phone',
          label: 'Telefon'
        },
        {
          fieldId: 'role',
          label: 'Roll',
          dataType: 'translate',
          translations: [{
            key: 'Staff',
            value: 'Konsult'
          }, {
            key: 'SuperAdmin',
            value: 'Superadmin'
          }, {
            key: 'Developer',
            value: 'Utvecklare'
          }]
        }]
      },

      actionMeta: {
        type: 'buttons',
        items: [{
          label: 'Radera',
          action: 'deleteUser',
          iconClass: 'fal fa-trash-alt'
        },
        {
          label: 'Ändra',
          action: 'updateUser',
          iconClass: 'fal fa-pen'
        },
        {
          label: 'Byt PIN',
          action: 'updatePin',
          iconClass: 'fal fa-key'
        }]
      }
    }
  },
  watch: {
    'users.filter': {
      handler () {
        this.getListData(1)
      },
      deep: true
    }
  },

  computed: {
    ...mapState({
      users: state => state.users.all
    })
  },

  methods: {
    ...mapActions('users', ['initialize', 'getListData', 'delete']),

    rowAction (action, user) {
      switch (action) {
        case 'updateUser':
          this.openUserModal(user.userId)
          break
        case 'updatePin':
          this.openPinModal(user)
          break
        case 'deleteUser':
          this.deleteUser(user)
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    fieldAction (action, user) {
      switch (action) {
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    openUserModal (id) {
      this.$panel(UserModal, { id })
    },

    openPinModal (user) {
      this.$panel(UserPinModal, { user })
    },

    deleteUser (user) {
      this.$confirm('Radera användare', 'Är du säker på att du vill radera användaren ' + user.firstName + ' ' + user.lastName + '?').then((result) => {
        if (result.value) {
          this.delete(user.userId)
          this.getListData(1)
        }
      })
    }
  },

  created () {
    this.initialize()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/SuperAdmin/UsersPage.vue